/**
 * Set by the backend on every bank-return landing URL (BankingSettingsService.WithPaymentFlowMarker). Its presence
 * is the deterministic "the customer is arriving from the payment flow" signal — history views never carry it.
 */
export const PAYMENT_FLOW_PARAM = "paymentFlow";

/**
 * Matches `paymentFlow=1` as its own parameter. Deliberately not `URLSearchParams`: some banks (Moneta) append their
 * own parameters with a second "?" (`?paymentFlow=1?response_code=ERROR`), which URLSearchParams folds into the
 * marker's value and the marker is then missed.
 */
const PAYMENT_FLOW_MARKER = /[?&]paymentFlow=1(?=$|[?&#])/;

export const hasPaymentFlowMarker = (search: string) =>
  PAYMENT_FLOW_MARKER.test(search);
